import { regExp } from '@sigma-frontend-libs/commons'

import { processors, proxy } from '@/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy({ type: 'object' }), processors ],

  props: {
    isNew: Boolean,

    errors: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    validation() {
      if (!this.proxy.title) {
        return false
      }

      if (!this.proxy.host) {
        return false
      }

      if (!regExp.ports.test(String(this.proxy.port ?? ''))) {
        return false
      }

      // https://gitlab-y7r4iuqy1m.sigmasms.ru/sigma/legacy/backend/-/blob/d3c51a3da559142a5ba4965ac5e3da1f44c3dfda/src/services/v1.servers/settings.js#L19
      if (Number(this.proxy.port) > 64000) {
        return false
      }

      if (!this.proxy.processor) {
        return false
      }

      return true
    }
  },

  watch: {
    validation() {
      this.$emit('validation', this.validation)
    }
  },

  mounted() {
    this.$emit('validation', this.validation)
  },

  render
}
